import React, { useReducer, useEffect } from 'react'; // 👈 Added useEffect
import {
    GET_ACCOMODATION_POSSIBLE_CATEGORY_TYPES,
    GET_CATEGORY_TYPES, GET_COUNTRIES, GET_FEEDBACKS, GET_POSSIBLE_CATEGORY_TYPES, GET_POSSIBLE_CATEGORY_VALUES,
    GET_SERVICE_POINTS, SET_LOADING, SET_PAGINATION, SET_SIDEBAR, SHOW_SELECT
} from '../types';
import { useNavigate } from 'react-router-dom';

// 1. 👈 Import the custom Axios instance and the setup function
import axiosInstance, { setupGlobalInterceptor } from '../../services/axios.service'; // Adjust path if needed
import ResourceReducer from './resourceReducer';
import ResourceContext from './resourceContext';
import storage from '../../helpers/storage';
import { currentPath, loginUrlFor } from '../../helpers/redirect';

const ResourceState = (props) => {
    const navigate = useNavigate();

    const initialState = {
        showSelect: '',
        servicePoints: [],
        countries: [],
        feedbacks: [],
        possibleCategoryValues: {},
        categoryTypes: [],
        possibleTypes: [],
        accomodationPossibleTypes: [],
        sidebar: {},
        loading: false,
    };

    const [state, dispatch] = useReducer(ResourceReducer, initialState);

    // The centralized logout function passed to the interceptor
    const logout = () => {
        storage.clearAuth();
        // Back to where they were once they sign in again.
        navigate(loginUrlFor(currentPath()));
        setLoading(false); // 👈 Important: Set loading to false after redirect
    };

    // 2. 👈 Use useEffect to set up the interceptor once on mount
    useEffect(() => {
        // Pass the local logout function to the global interceptor setup
        setupGlobalInterceptor(logout);
        // We only rely on 'logout' here because it contains the navigation logic.
    }, []); // Empty dependency array means it runs only once

    const getSelect = (val) => {
        dispatch({
            type: SHOW_SELECT,
            payload: val
        });
    };

    const getFeedbacks = async () => {
        setLoading();
        try {
            // 3. 👈 Switched from Axios to axiosInstance
            const resp = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/`);
            dispatch({
                type: GET_FEEDBACKS,
                payload: resp.data.data.docs
            });
            setLoading(false);
        } catch (error) {
            // 4. ❌ REMOVED manual 401 check, handled by global interceptor
            console.error('Error fetching feedbacks:', error);
        }
    };

    const getCategoryTypes = async () => {
        setLoading();
        try {
            const resp = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/category-types`, storage.getConfigWithBearer());
            dispatch({
                type: GET_CATEGORY_TYPES,
                payload: resp.data.data.docs
            });
            setLoading(false);
        } catch (error) {
            console.error('Error fetching category types:', error);
        }
    };

    const createKeysFromPossibleValues = (possibleValues) => {
        let result = {};
        for (let possibleValue of possibleValues) {
            if (result[possibleValue.title]) continue;
            result[possibleValue.title] = possibleValue.values;
        }
        return result;
    };

    const getPossibleTypes = async () => {
        setLoading();
        try {
            // 3. 👈 Switched from Axios to axiosInstance
            const resp = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/resource-groups/possible-categories`, storage.getConfigWithBearer());

            let payload = resp.data.data;

            dispatch({
                type: GET_POSSIBLE_CATEGORY_TYPES,
                payload
            });

            dispatch({
                type: GET_POSSIBLE_CATEGORY_VALUES,
                payload: createKeysFromPossibleValues(payload)
            });
        } catch (error) {
            // 4. ❌ REMOVED manual 401 check, handled by global interceptor
            console.error('Error fetching possible types:', error);
        }
    };

    const getAcomodationPossibleTypes = async () => {
        setLoading();
        try {
            // 3. 👈 Switched from Axios to axiosInstance
            const resp = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/resource-groups/accomodation-possible-categories`, storage.getConfigWithBearer());

            let payload = resp.data.data;

            // Its own slot: accommodation criteria and resource-group
            // criteria are different lists, and both used to be written to
            // the same one.
            dispatch({
                type: GET_ACCOMODATION_POSSIBLE_CATEGORY_TYPES,
                payload
            });
        } catch (error) {
            // 4. ❌ REMOVED manual 401 check, handled by global interceptor
            console.error('Error fetching possible types:', error);
        }
    };

    const getServicePoints = async (eventId) => {
        setLoading();
        try {
            // 3. 👈 Switched from Axios to axiosInstance
            const resp = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/service-points?event=${eventId}`, storage.getConfigWithBearer());
            dispatch({
                type: GET_SERVICE_POINTS,
                payload: resp.data.data.docs
            });
            setLoading(false);
        } catch (error) {
            // 4. ❌ REMOVED manual 401 check, handled by global interceptor
            console.error('Error fetching service points:', error);
        }
    };


  const getCountries = async () => {
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/participants/countries?_order=asc`,
        storage.getConfigWithBearer()
      );

      dispatch({
        type: GET_COUNTRIES,
        payload: resp.data.data,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getAccomodations:", error);

    }
  };

    const setSidebar = (a, l) => {
        dispatch({
            type: SET_SIDEBAR,
            payload: { active: a, label: l }
        });
    };

    const setLoading = () => { 
        dispatch({
            type: SET_LOADING,
        });
    };

    return (
        <ResourceContext.Provider value={{
            showSelect: state.showSelect,
            countries: state.countries,
            servicePoints: state.servicePoints,
            feedbacks: state.feedbacks,
            categoryTypes: state.categoryTypes,
            possibleTypes: state.possibleTypes,
            accomodationPossibleTypes: state.accomodationPossibleTypes,
            possibleCategoryValues: state.possibleCategoryValues,
            sidebar: state.sidebar,
            loading: state.loading,
            getCountries,
            getFeedbacks,
            getPossibleTypes,
            getCategoryTypes,
            getAcomodationPossibleTypes,
            getServicePoints,
            getSelect,
            setSidebar
        }}
        >
            {props.children}

        </ResourceContext.Provider>
    );
};

export default ResourceState;